var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightEndIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/arrow-right-end-on-rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 3.125C14.4404 3.125 15 3.68464 15 4.375L15 15.625C15 16.3154 14.4404 16.875 13.75 16.875H8.75C8.05964 16.875 7.5 16.3154 7.5 15.625V12.5C7.5 12.1548 7.22018 11.875 6.875 11.875C6.52982 11.875 6.25 12.1548 6.25 12.5V15.625C6.25 17.0057 7.36929 18.125 8.75 18.125H13.75C15.1307 18.125 16.25 17.0057 16.25 15.625L16.25 4.375C16.25 2.99429 15.1307 1.875 13.75 1.875L8.75 1.875C7.36929 1.875 6.25 2.99429 6.25 4.375V7.5C6.25 7.84518 6.52982 8.125 6.875 8.125C7.22018 8.125 7.5 7.84518 7.5 7.5V4.375C7.5 3.68464 8.05964 3.125 8.75 3.125L13.75 3.125ZM9.55806 7.05806C9.31398 7.30214 9.31398 7.69787 9.55806 7.94194L10.9911 9.375L1.875 9.375C1.52982 9.375 1.25 9.65482 1.25 10C1.25 10.3452 1.52982 10.625 1.875 10.625L10.9911 10.625L9.55806 12.0581C9.31398 12.3021 9.31398 12.6979 9.55806 12.9419C9.80214 13.186 10.1979 13.186 10.4419 12.9419L12.9419 10.4419C13.186 10.1979 13.186 9.80214 12.9419 9.55806L10.4419 7.05806C10.1979 6.81398 9.80213 6.81398 9.55806 7.05806Z",
    fill: "#3F3B54"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightEndIcon);
export default __webpack_public_path__ + "static/media/ArrowRightEndIcon.ee7335a3e51a604fe986513832b021af.svg";
export { ForwardRef as ReactComponent };